import Css from "../../style.module.scss";

import { FormElement } from "nlib/common/Form";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Checkbox from "nlib/ui/Checkbox";
import IntegrationServices from "const/IntegrationServices";
import React, { useMemo } from "react";
import Texts from "utils/Texts";

const AiBookkeeperTabAutomation = ({ integrationService }) => {
  const { messages } = useSelector(getTextsData);

  const [matchTransactionsQboText, matchTransactionsXeroText] = messages.settingsMatchTransactions;

  const [matchTransactionsQboDescription, matchTransactionsXeroDescription] = messages.settingsMatchTransactionsDescription;

  const integrationServiceLabel = useMemo(() => {
    return IntegrationServices.getByValue(integrationService).label;
  }, [integrationService]);

  const matchTransactionsText = useMemo(() => {
    return integrationService === IntegrationServices.QUICK_BOOKS.value ? matchTransactionsQboText : matchTransactionsXeroText;
  }, [integrationService, matchTransactionsQboText, matchTransactionsXeroText]);

  const matchTransactionsDescription = useMemo(() => {
    return integrationService === IntegrationServices.QUICK_BOOKS.value
      ? matchTransactionsQboDescription
      : matchTransactionsXeroDescription;
  }, [integrationService, matchTransactionsQboDescription, matchTransactionsXeroDescription]);

  return (
    <>
      <div className={Css.row}>
        <div className={Css.col}>
          <FormElement toggle name="rpaAutoApprove" element={Checkbox}>
            <span>
              {Texts.replaceVars(
                messages.autoExportReadyEntriesToggleLabelText,
                { system: integrationServiceLabel }
              )}
            </span>
          </FormElement>
          <div className={Css.description}>
            {Texts.replaceVars(
              messages.autoExportReadyEntriesToggleDescription,
              { system: integrationServiceLabel }
            )}
          </div>
        </div>
      </div>
      <div className={Css.row}>
        <div className={Css.col}>
          <FormElement toggle name="rpaMatchingEnabled" element={Checkbox}>
            <span>{matchTransactionsText}</span>
          </FormElement>
          <div className={Css.description}>{matchTransactionsDescription}</div>
        </div>
      </div>
      <div className={Css.row}>
        <div className={Css.col}>
          <FormElement toggle name="allowApproveWithoutPayee" element={Checkbox}>
            <span>
              {Texts.replaceVars(
                messages.approveWithoutPayeeToggleLabelText,
                { system: integrationServiceLabel }
              )}
            </span>
          </FormElement>
          <div className={Css.description}>
            {Texts.replaceVars(
              messages.approveWithoutPayeeToggleDescription,
              { system: integrationServiceLabel }
            )}
          </div>
        </div>
      </div>
      <div className={Css.row}>
        <div className={Css.col}>
          <FormElement toggle name="allowAutoCreatePayee" element={Checkbox}>
            <span>{messages.autoCreatePayeeToggleLabelText}</span>
          </FormElement>
          <div className={Css.description}>{messages.autoCreatePayeeToggleDescription}</div>
        </div>
      </div>
    </>
  );
};

export default AiBookkeeperTabAutomation;
